"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { Facebook, Instagram, Linkedin, Mail, MapPin, Phone, Twitter } from "lucide-react";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <ul className="space-y-3">
        {[1, 2, 3, 4].map((_, i) => <li key={i} data-index={i}>
            <div className="h-5 w-24 bg-muted animate-pulse rounded-md" />
          </li>)}
      </ul>;
  }
  if (!menuItems || menuItems.length === 0) {
    return <ul className="space-y-3">
        <li data-index={0}><Link to="#" className="text-muted-foreground hover:text-primary transition-colors">Home</Link></li>
        <li data-index={1}><Link to="#" className="text-muted-foreground hover:text-primary transition-colors">Composite & Trex Decks</Link></li>
        <li data-index={2}><Link to="#" className="text-muted-foreground hover:text-primary transition-colors">Wood Deck Builders</Link></li>
      </ul>;
  }
  return <ul className="space-y-3">
      {menuItems.map((item, i) => <li key={item.id} data-index={i}>
          <Link to={item.href || "#"} className="text-muted-foreground hover:text-primary transition-colors">
            {item.label}
          </Link>
        </li>)}
    </ul>;
}
export default function Footer() {
  const currentYear = new Date().getFullYear();
  const socialLinks = [{
    icon: Facebook,
    href: "https://facebook.com",
    label: "Facebook"
  }, {
    icon: Twitter,
    href: "https://twitter.com",
    label: "Twitter"
  }, {
    icon: Linkedin,
    href: "https://linkedin.com",
    label: "LinkedIn"
  }, {
    icon: Instagram,
    href: "https://instagram.com",
    label: "Instagram"
  }];
  return <section data-section-id="213225" id="pch-builders-footer" className="dark bg-background text-foreground pt-16 pb-8 border-t border-border">
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16">
          {}
          <div className="space-y-6">
            <Link to="/" className="inline-block">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1631011/img/inspectpro_footer_logo.png" alt="PCH Builders Logo" className="h-7 w-auto" />
            </Link>
            <p className="text-muted-foreground leading-relaxed max-w-xs font-default">
              PCH Builders is a premier California deck company. Since 1990, we have specialized in high-end deck installation, composite decking, and custom outdoor structures for luxury living.
            </p>
          </div>

          {}
          <div className="space-y-6">
            <h3 className="text-lg font-semibold font-default tracking-tight uppercase">Deck Services</h3>
            <MenuProvider menu_id="46">
              <FooterMenuConsumer />
            </MenuProvider>
          </div>

          {}
          <div className="space-y-6">
            <h3 className="text-lg font-semibold font-default tracking-tight uppercase">Service Areas</h3>
            <ul className="space-y-4">
              <li data-index={0}>
                <Link to="#" className="flex items-start gap-3 text-muted-foreground hover:text-primary transition-colors group">
                  <MapPin className="size-5 shrink-0 mt-0.5 text-primary/80 group-hover:text-primary transition-colors" />
                  <span className="font-default">San Francisco, Santa Clara, Santa Cruz & Monterey Counties</span>
                </Link>
              </li>
              <li data-index={1}>
                <Link to="tel:(925) 529-5005" className="flex items-center gap-3 text-muted-foreground hover:text-primary transition-colors group">
                  <Phone className="size-5 shrink-0 text-primary/80 group-hover:text-primary transition-colors" />
                  <span className="font-default">(925) 529-5005</span>
                </Link>
              </li>
              <li data-index={2}>
                <Link to="mailto:info@pchbuilders.com" className="flex items-center gap-3 text-muted-foreground hover:text-primary transition-colors group">
                  <Mail className="size-5 shrink-0 text-primary/80 group-hover:text-primary transition-colors" />
                  <span className="font-default">info@pchbuilders.com</span>
                </Link>
              </li>
            </ul>
          </div>

          {}
          <div className="space-y-6">
            <h3 className="text-lg font-semibold font-default tracking-tight uppercase">Direct Contact</h3>
            <div className="flex flex-wrap gap-3">
              {socialLinks.map((social, i) => {
              const Icon = social.icon;
              return <Link key={social.label} data-index={i} to={social.href} newTab aria-label={social.label} className="flex items-center justify-center size-10 rounded-sm border border-border text-muted-foreground hover:border-primary hover:text-primary hover:bg-primary/10 transition-all duration-300">
                    <Icon className="size-4" />
                  </Link>;
            })}
            </div>
          </div>
        </div>

        {}
        <div className="pt-8 border-t border-border flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-sm text-muted-foreground font-default">
            &copy; {currentYear} PCH Builders. All rights reserved.
          </p>
          <p className="text-sm font-medium text-muted-foreground/80 flex items-center gap-2 font-default">
            <span className="size-1.5 rounded-full bg-primary inline-block"></span>
            Licensed General Contractor #XXXXXX
          </p>
        </div>
      </div>
    </section>;
}